import type { AdminReviewListItemResponse } from "../../../types/adminTypes";

export const getFullName = (
  firstName?: string | null,
  lastName?: string | null,
  fallback = "Unknown user",
) => {
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  return fullName || fallback;
};

export const getReviewContextLabel = (reviewContext: AdminReviewListItemResponse["reviewContext"]) => {
  if (reviewContext === "WORKER_PERFORMANCE") {
    return "Worker performance";
  }
  if (reviewContext === "POSTER_EXPERIENCE") {
    return "Poster experience";
  }
  return "Unknown context";
};

export const getReviewContextTone = (
  reviewContext: AdminReviewListItemResponse["reviewContext"],
): "neutral" | "success" | "warning" => {
  if (reviewContext === "WORKER_PERFORMANCE") {
    return "success";
  }
  if (reviewContext === "POSTER_EXPERIENCE") {
    return "warning";
  }
  return "neutral";
};

export const getStatusTone = (status?: string | null): "neutral" | "success" | "warning" | "danger" => {
  if (!status) {
    return "neutral";
  }
  if (status === "FILLED" || status === "POSTER_ACCEPTED") {
    return "success";
  }
  if (status.includes("PENDING") || status === "PUBLISHED") {
    return "warning";
  }
  if (status.includes("REJECTED") || status === "CANCELLED" || status === "WITHDRAWN" || status.startsWith("REMOVED")) {
    return "danger";
  }
  return "neutral";
};
